module.exports = __webpack_public_path__ + "dung.b973809b.png";